/* eslint-disable react/prop-types */
import { Space, Typography } from "antd";
import { format, isValid } from "date-fns";

export default function UpdatedByCell({ value }) {
  if (!value) return "-";

  let updatedBy = value.updatedBy;
  if (typeof updatedBy === "object" && updatedBy !== null) {
    updatedBy =
      updatedBy.fullName ||
      updatedBy.name ||
      updatedBy.username ||
      updatedBy.email ||
      null;
  }
  let updatedAt = value.updatedAt || value.time || value.createdAt;

  // Jika updatedBy kosong, cari dari status verifikasi sebelumnya yang memiliki updatedBy
  if (!updatedBy) {
    const verifications =
      value.verificationStatusses ||
      value.verificationStatuses ||
      value.verifications ||
      [];

    if (Array.isArray(verifications) && verifications.length > 0) {
      const validVerifications = verifications
        .filter((v) => v?.updatedBy)
        .sort(
          (a, b) =>
            new Date(b.time || b.updatedAt || b.createdAt || 0) -
            new Date(a.time || a.updatedAt || a.createdAt || 0)
        );

      if (validVerifications.length > 0) {
        const latestValid = validVerifications[0];
        updatedBy =
          typeof latestValid.updatedBy === "object"
            ? latestValid.updatedBy.name || latestValid.updatedBy.username
            : latestValid.updatedBy;
        updatedAt =
          latestValid.time ||
          latestValid.updatedAt ||
          latestValid.createdAt ||
          updatedAt;
      }
    }

    // Fallback jika ada properti objek verifikasi terpisah
    if (!updatedBy) {
      const fallbacks = [
        value.programVerification,
        value.facilityVerification,
        value.legalityVerification,
      ];
      for (const item of fallbacks) {
        if (item?.updatedBy) {
          updatedBy =
            typeof item.updatedBy === "object"
              ? item.updatedBy.name || item.updatedBy.username
              : item.updatedBy;
          updatedAt =
            item.time || item.updatedAt || item.createdAt || updatedAt;
          break;
        }
      }
    }
  }

  // Format tanggal dengan aman
  let formattedDate = null;
  if (updatedAt) {
    const dateObj = new Date(updatedAt);
    if (isValid(dateObj)) {
      formattedDate = format(dateObj, "dd/MM/yyyy - HH.mm");
    }
  }

  if (!updatedBy && !formattedDate) {
    return "-";
  }

  return (
    <Space direction="vertical" size={2}>
      <Typography.Text style={{ marginBottom: 0, fontWeight: 600 }}>
        {updatedBy ?? "-"}
      </Typography.Text>
      {formattedDate && (
        <Typography.Text
          type="secondary"
          style={{ fontSize: "13px", fontStyle: "italic" }}
        >
          {formattedDate}
        </Typography.Text>
      )}
    </Space>
  );
}

